export default __webpack_public_path__ + "static/media/25c0e81c-dea6-4432-8b35-6b471f59c065.bca7e4ea.JPG";